import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: { username: string; password: string }) {
    const baseUrl = 'auth/prelogin';
    return api.create(`${baseUrl}`, params);
}

function afterlogin(params: { id_aplikasi:string, id_user:string,username:string, kode_cabang:number,person_area:string,note:string,panel:string,hak_akses_desc:string, hak_akses: string, nama:string, nama_jabatan:string,email:string }) {
    const baseUrl = 'auth/login';
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword, afterlogin };
